import axios from "axios";
import { BlobServiceClient } from "@azure/storage-blob";

const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
const contentImagesContainerName =
  process.env.REACT_APP_CONTENTIMAGES_STORAGE_CONTAINER;
const REFRESH_BUFFER_MS = 60_000;

const sasCache = new Map();

const fetchSasToken = async (container) => {
  const response = await axios.get(
    `${process.env.REACT_APP_CLIENTS_API_BASE_URL}/admin/storage/sas-token`,
    {
      params: { container },
      headers: { authorization: localStorage.getItem("token") },
    }
  );
  const expiresOn = Date.parse(response.data.expiresOn);
  return {
    sasToken: response.data.sasToken,
    storageAccountName: response.data.storageAccountName,
    expiresOn: Number.isFinite(expiresOn) ? expiresOn : 0,
  };
};

const getSas = async (container) => {
  const cached = sasCache.get(container);
  if (cached && cached.expiresOn - Date.now() >= REFRESH_BUFFER_MS) {
    return cached;
  }
  const fresh = await fetchSasToken(container);
  sasCache.set(container, fresh);
  return fresh;
};

const getContainerClient = async (container) => {
  const { sasToken, storageAccountName } = await getSas(container);
  const blobService = new BlobServiceClient(
    `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  );
  return blobService.getContainerClient(container);
};

export const getBlobsInContainer = async (prefix = "") => {
  const containerClient = await getContainerClient(containerName);
  const { storageAccountName } = await getSas(containerName);
  const returnedBlobUrls = [];

  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsByHierarchy("/", {
    prefix,
  })) {
    returnedBlobUrls.push({
      blobName: blob.name,
      blobUrl: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`,
    });
  }

  return returnedBlobUrls;
};

export const createBlobInContainer = async (file, prefix = "", blobName = file.name) => {
  const containerClient = await getContainerClient(containerName);
  const blobClient = containerClient.getBlockBlobClient(
    `${prefix}${blobName}`
  );
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  await blobClient.uploadData(file, options);
};

export const deleteBlobIfItExists = async (blobName) => {
  const containerClient = await getContainerClient(containerName);
  const blockBlobClient = containerClient.getBlockBlobClient(blobName);

  await blockBlobClient.deleteIfExists({ deleteSnapshots: "include" });
};

export const createContentImageInContainer = async (file, filename) => {
  const containerClient = await getContainerClient(contentImagesContainerName);
  const blobClient = containerClient.getBlockBlobClient(filename);
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  await blobClient.uploadData(file, options);
};
